export const bottomfindMyFriendsFeatures = [
    {
        id: '1',
        title: 'Never Lose Each Other',
        content: 'See your group’s location in real time, find each other’s parked cars, regroup easily at festivals, and avoid the stress of getting separated.',
        imgName: 'earth'
    },
    {
        id: '2',
        title: 'Check If Someone Got Home Safely',
        content: "No need to worry yourself waiting for a text; a quick glance at the app tells you everything you need to know.",
        imgName: 'checkCircleIcon'
    },
    {
        id: '3',
        title: 'Ideal for Travelling Together',
        content: "Whether you're exploring a new city or backpacking abroad, track your friends and stay safe with an emergency alert feature to alert the whole group if something is wrong.",
        imgName: 'mobilePhoneIcon'
    },
    {
        id: '4',
        title: 'One Membership For The Group',
        content: "With up to five devices in one tracking group, you don’t need to splash out on costly memberships for everyone. Only one of the group members needs to subscribe to the app and share the code with the rest.",
        imgName: 'eye'
    },
];